import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from './components/layout/MainLayout';
import { Dashboard } from './pages/Dashboard';
import { Bookings } from './pages/Bookings';
import { DiagnosticExams } from './pages/DiagnosticExams';
import { ReportEditorPage } from './pages/ReportEditorPage';
import { Doctors } from './pages/Doctors';
import { ReportTemplates } from './pages/ReportTemplates';
import { ReportTemplateDetail } from './pages/ReportTemplateDetail';
import { ReportTemplateCreate } from './pages/ReportTemplateCreate';
import { Machines } from './pages/Machines';
import { Calendar } from './pages/Calendar';
import { PatientPortal } from './pages/PatientPortal';
import { Patients } from './pages/Patients';
import { PatientDetail } from './pages/PatientDetail';
import { Settings } from './pages/Settings';
import { PatientReports } from './pages/PatientReports';
import { PatientExams } from './pages/PatientExams';
import { RoleProvider, useRole } from './hooks/useRole';
function ProtectedRoute({
  children,
  allowedRoles
}: {
  children: React.ReactNode;
  allowedRoles: string[];
}) {
  const {
    role
  } = useRole();
  if (!allowedRoles.includes(role)) {
    if (role === 'paziente') {
      return <Navigate to="/patient-reports" replace data-id="element-0" />;
    }
    return <Navigate to="/" replace data-id="element-1" />;
  }
  return <>{children}</>;
}
function AppRoutes() {
  const {
    role
  } = useRole();
  return <Routes data-id="element-2">
      {/* Main Application Routes */}
      <Route element={<MainLayout data-id="element-4" />} data-id="element-3">
        <Route path="/" element={role === 'paziente' ? <Navigate to="/patient-reports" replace data-id="element-6" /> : <Dashboard data-id="element-7" />} data-id="element-5" />
        <Route path="/bookings" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-9">
              <Bookings data-id="element-10" />
            </ProtectedRoute>} data-id="element-8" />
        <Route path="/exams" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-12">
              <DiagnosticExams data-id="element-13" />
            </ProtectedRoute>} data-id="element-11" />
        <Route path="/exams/report/:id" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-15">
              <ReportEditorPage data-id="element-16" />
            </ProtectedRoute>} data-id="element-14" />
        <Route path="/doctors" element={<ProtectedRoute allowedRoles={['superadmin']} data-id="element-18">
              <Doctors data-id="element-19" />
            </ProtectedRoute>} data-id="element-17" />
        <Route path="/templates" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-21">
              <ReportTemplates data-id="element-22" />
            </ProtectedRoute>} data-id="element-20" />
        <Route path="/templates/new" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-24">
              <ReportTemplateCreate data-id="element-25" />
            </ProtectedRoute>} data-id="element-23" />
        <Route path="/templates/:id" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-27">
              <ReportTemplateDetail data-id="element-28" />
            </ProtectedRoute>} data-id="element-26" />
        <Route path="/machines" element={<ProtectedRoute allowedRoles={['superadmin']} data-id="element-30">
              <Machines data-id="element-31" />
            </ProtectedRoute>} data-id="element-29" />
        <Route path="/calendar" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-33">
              <Calendar data-id="element-34" />
            </ProtectedRoute>} data-id="element-32" />
        <Route path="/reports" element={<Navigate to="/exams" replace data-id="element-36" />} data-id="element-35" />
        <Route path="/patients" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-38">
              <Patients data-id="element-39" />
            </ProtectedRoute>} data-id="element-37" />
        <Route path="/patients/:id" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-41">
              <PatientDetail data-id="element-42" />
            </ProtectedRoute>} data-id="element-40" />
        <Route path="/patient-reports" element={<ProtectedRoute allowedRoles={['paziente', 'superadmin', 'medico']} data-id="element-44">
              <PatientReports data-id="element-45" />
            </ProtectedRoute>} data-id="element-43" />
        <Route path="/patient-exams" element={<ProtectedRoute allowedRoles={['paziente', 'superadmin', 'medico']} data-id="element-47">
              <PatientExams data-id="element-48" />
            </ProtectedRoute>} data-id="element-46" />
        <Route path="/settings" element={<ProtectedRoute allowedRoles={['superadmin', 'medico']} data-id="element-50">
              <Settings data-id="element-51" />
            </ProtectedRoute>} data-id="element-49" />
      </Route>

      {/* Patient Portal Route (Legacy Redirect) */}
      <Route path="/patient-portal" element={<Navigate to="/patient-reports" replace data-id="element-53" />} data-id="element-52" />
    </Routes>;
}
export function App() {
  return <RoleProvider data-id="element-54">
      <BrowserRouter data-id="element-55">
        <AppRoutes data-id="element-56" />
      </BrowserRouter>
    </RoleProvider>;
}